import 'phaser'
//import '@babel/polyfill'
/* "esversion" : 6 */
import MainScene from './scenes/mainScene.js'
import PreloadScene from './scenes/preloadScene.js'
//import PhaserScene from './scenes/phaserScene.js'
import EndScene from './scenes/endScene.js'

const DEFAULT_WIDTH =1080;
const DEFAULT_HEIGHT = 1920;

export const config = {
  width: DEFAULT_WIDTH,
  height: DEFAULT_HEIGHT,
  type: Phaser.AUTO,
  backgroundColor: '#076b05',
  parent: 'gameDiv',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [PreloadScene, MainScene, EndScene],
  //scene:
   //{ preload: preload,
    //create: create,
    //update: update},
  physics: {
    //這是物理引擎
    default: 'arcade',
    //預設的引擎模式，夠大部分物理動作適用
    arcade: {
      debug: false,
      gravity: { y: 300 }
    }
  }
}


//function callmetest()
//{
	//'use strict';
	//alert("I am call test.js");
//}

//module.exports = config;//

window.addEventListener('load', () => {
  const game = new Phaser.Game(config);
})


